import React, { useEffect, useState } from 'react';
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import styles from "./detailedview.module.scss";
import { Spin } from 'antd';
import * as utils from '../../utils/utils';
import * as consts from '../../utils/constant';
import * as favUtils from '../../utils/favorite.utils';
import * as constants from "../../../src/utils/constant";
import * as nbaurls from "../../../src/utils/nba.utils";
import Attributes from '../attributes/subRegion';
import KPIScore from './Tiles/Redesign/KPIScore';
//import CAS from './Tiles/Redesign/CAS';
import CXScore from './Tiles/Redesign/CXScore';
import { CreateScoreLinks } from '../score/Score.utils';
import CustCAS from './Tiles/Redesign/CustCAS';


const SubRegion = (props) => {
    const favInput = JSON.parse(JSON.stringify(props.favInput));
    const { selectedSubRegion } = props;
    let [FavoriteId, setFavoriteId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [subRegionDetails, setSubRegionDetails] = useState(null)
    const primaryRecommendation = (selectedSubRegion && selectedSubRegion.primaryRecommendation && selectedSubRegion.primaryRecommendation.length>0) ?  Array.isArray(selectedSubRegion.primaryRecommendation)? selectedSubRegion.primaryRecommendation[0].toLocaleLowerCase() : selectedSubRegion.primaryRecommendation.toLocaleLowerCase() : ""
    const secondaryRecommendations = (selectedSubRegion && selectedSubRegion.secondaryRecommendations) ? selectedSubRegion.secondaryRecommendations : [];
    const [region] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release-
    const [isattrSectionLoaded,setIsSectionLoaded] = useState(false);
    const [KPI,setKPI] = useState(null)
    const [cxScr, setCxScore] = useState(null)
    let level='subregion'

    const isSectionLoaded = (input)=>{
        setIsSectionLoaded(input)
    }
    const breadcrumbList = [
        {
            value: `Dashboard (${region})`,
            path: "/dashboard",
        },
        {
            value: `${selectedSubRegion.code} (${region})`,
            path: "/",
        }
      ];

    const formatData = (result) => {
        let subRegionData;
        let hitsArray = (result.hits && result.hits.hits && result.hits.hits.length > 0) ? result.hits.hits[0] : [];
        subRegionData = (hitsArray && hitsArray?._source) ? hitsArray?._source?.group : [];
        let filteredSubRegionData = subRegionData.filter((item) => item.code.toLowerCase() === selectedSubRegion.code.toLowerCase() )[0];
        return filteredSubRegionData;
    }

    useEffect(() => {
        //props.setIsSubregion(false)
        const input = {
            name: constants.SubRegion_Score_Index,
            queryParams: {
                "query": {
                    "match_all": {}
                }
            }
        }    
        setLoading(true)
        utils.getDataES('-elasticsearch', 'POST', input)
            .then(resp => {
                let groupESData = formatData(resp.data);
                //const {company_region, KpiScoreTrends, cxList} = groupESData
                //kpiHandler(groupESData, KpiScoreTrends, cxList);
                setSubRegionDetails(groupESData)
                props.setKPI({})
                props.setCXScoreData(groupESData);//added kpiToPB
                setLoading(false)
            }).catch(err => setLoading(false))
    }, [])

    let cxScore, cas, cxList, cxListDP ,cxKeys, cxValues,cxScoreTrend;
    const getSortedCXList = (cxList) => {
        let list = [...cxList]
        list.forEach(element => {
            element.difference = element.score - element.lastQuarterValue
            element.differenceCent = ((element.score - element.lastQuarterValue) / (element.lastQuarterValue)) * 100
        });
        return list.sort(utils.sorting('differenceCent', 'number', false))
    }

    if (subRegionDetails) {
        cxScore = subRegionDetails.cxScore;
        if (subRegionDetails && subRegionDetails.cxList && subRegionDetails.cxList.length > 0) {
            cxListDP = subRegionDetails.cxList.find(item => item.name.toLowerCase() === consts.HELD_ORDER_INDEX.toLowerCase());
            cxScore.dataPoints = (cxListDP && cxListDP.dataPoints) ? cxListDP.dataPoints : ''
        }
        cas = subRegionDetails.cas;
        cxList = getSortedCXList(subRegionDetails.cxList);//Need to investigate where we are using this cxList, as we are not using it in the subregion page.
    }

    const createBreadCrumb = () => {
        breadcrumbList[breadcrumbList.length - 1].path = '/dashboard/subregiondetail'
        return breadcrumbList;
    }

    const viewScore = (score, item) => {
        //props.setCXScoreData(subRegionDetails);
        props.setBreadCrumb(createBreadCrumb());
        if (score === 'cas') {
            props.setKPI();
            props.setSASParent('cas');
            props.history.push("/dashboard/score/cas");//need to check
        } else if (score === 'cx') {
            props.setKPI();
            props.setSASParent('cx');
            props.history.push("/dashboard/score"); //need to check
        } else {
            console.log("My KPI Item is", item)
            props.setSASParent('kpi');
            props.setKPI(item);
            //props.setBannerType(item.name.toLowerCase().replace(/\s+/g, ''));
            props.history.push("/dashboard/primaryview");
        }
    };

    const getInsights = (nba) => {
        if (subRegionDetails.nba_insights) {
            let insights = subRegionDetails.nba_insights.filter(element => element.metrics_name.toLowerCase() === nba.toLowerCase())
            if (insights && insights.length) {
                return insights[0].insights
            }
            return []
        }
        return []
    }

    
    const primaryView = (nba) => {
        let _nba;
        const { code } = props.selectedSubRegion;
        let subreg_urls = nbaurls.sr_nba_urls(nba, code, region)
        switch (nba) {
            case consts.IMPROVE_INVOICE_AGING:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.IMPROVE_INVOICE_AGING)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_INVOICE_AGING.replace(/\s+/g, ''));
                break;
            case consts.REDUCE_RETURN_PERCENTAGE:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.REDUCE_RETURN_PERCENTAGE)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.REDUCE_RETURN_PERCENTAGE.replace(/\s+/g, ''));
                break;
            case consts.IMPROVE_PRODUCT_AVAILABILITY:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.IMPROVE_PRODUCT_AVAILABILITY)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_PRODUCT_AVAILABILITY.replace(/\s+/g, ''));
                break;
            case consts.NEW_IMPROVE_ORDER_VELOCITY:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.NEW_IMPROVE_ORDER_VELOCITY)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.NEW_IMPROVE_ORDER_VELOCITY.replace(/\s+/g, ''));
                break;
            case consts.IMPROVE_OTIF:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.IMPROVE_OTIF)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.IMPROVE_OTIF.replace(/\s+/g, ''));
                break;
            case consts.INCREASE_CREDITLINE:
                _nba = {
                    name: nba,
                    primaryView: subreg_urls.primaryView,
                    childView: subreg_urls.childView,
                    historyView: subreg_urls.historyView,
                    insights: getInsights(consts.INCREASE_CREDITLINE)
                }
                props.setNBA(_nba);
                props.setBannerType(consts.INCREASE_CREDITLINE.replace(/\s+/g, ''));
                break;
            default:
                break;
        }

        props.setNBABreadCrumb(createBreadCrumb())
        props.history.push('/dashboard/nba/primaryview')
    }

    async function getFavorites() {
        const favorites = await favUtils.getFavorites()
        props.setFavorite(favorites)
    }

    async function addToFavorite(isAlreadyFavorite) {
        try {
            setLoading(true)
            if (!isAlreadyFavorite) {
                favInput.UserId = utils.getUserEmail()
                favInput.ViewType = 1
                favInput.region = region
                favInput.InputParameters.subregion = selectedSubRegion;//added for EMEA release
                if(Object.keys(selectedSubRegion).length > 0)//added for EMEA release
                favInput.InputParameters.group.company_region = favInput.InputParameters.subregion.company_region;
                const FavoriteId = await favUtils.addFavorites(favInput)
                setFavoriteId(FavoriteId)
            } else {
                await favUtils.removeFavorites(FavoriteId)
                setFavoriteId(null)
            }
            setLoading(false)
            getFavorites()
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    useEffect(() => {
        setFavoriteId(favUtils.chkIsFavorite(
            props.favorites,
            region, //added for EMEA release
            1,
            {},
            {},
            {},
            '',
            '',
            selectedSubRegion))//Need to modify it
    }, [])

    //added kpiToPB
    useEffect(() => {
            if (props.cxScoreDetails && subRegionDetails) {
                console.log("subRegionDetails.js UseEffect--props", props);
                const navList = CreateScoreLinks(props, false); console.log("CreateScoreLinks In UseEffect--subRegionDetails.js", navList, subRegionDetails)
                const { KpiScoreTrends, cxList } = subRegionDetails;
                kpiHandler(subRegionDetails, KpiScoreTrends, cxList, navList);
            }
    }, [props.cxScoreDetails, subRegionDetails])
  
const kpiHandler = (subregion, KpiScoreTrends, cxList, navList) => {console.log("My KPI--kpiHandler--All Inputs--sbs", subregion,"KpiScoreTrends",KpiScoreTrends,"cxList",cxList,"navList",navList);
let kpiSortedList, newKpiList;

    kpiSortedList = getSortedCXList(cxList);  console.log("My KPI Sorted List",kpiSortedList); 
    newKpiList = kpiSortedList.map( (item) => {
       let newKPIMergedObj, kpiName, navItm; 
       kpiName = item.name.split(" ").join("").toLowerCase(); console.log("My KPI kpiSortedList--List name",kpiName)
       navItm= navList.find((item => item.name.split(" ").join("").toLowerCase()=== kpiName));

       let {primary, child, history} = navItm;
       for (const [key, value] of Object.entries(KpiScoreTrends)) { console.log(`My KPI ${key}: ${value}`);
           let kpiName_scoreTrend = key.split(" ").join("").toLowerCase();
           if(kpiName===kpiName_scoreTrend){//compare cxList KPI name and kpiScoretrend kpi name 
              let keys, values;
               keys = value.quarterly.map(key=>key.period_value);
               values = handleKPIChartValues(value,kpiName) ;  console.log("MY KPI Score trend Keys-----",keys);  console.log("My KPI Score trend Values-----",values);
               
               newKPIMergedObj={...item, ...value, kpiKeys:keys, kpiValues:values, primary, child, history } ; console.log("My KPI newKPIMergedObj",newKPIMergedObj)
           }   
       }
       return newKPIMergedObj
   }); console.log("My KPI MergedList with Primary/Hist/Child",newKpiList);
   setKPI(newKpiList)

   cxScoreTrend = subregion.CXScoreTrend; console.log("sbs, cxScoreTrend", cxScoreTrend);

   for (const [key, value] of Object.entries(cxScoreTrend)) {
       if(key==="quarterly"){
           cxKeys = cxScoreTrend[key].map(ky=>ky.period_value); console.log("cxKeys",cxKeys, value);
           cxValues = handleKPIChartValues(value,"cxScoreTrend"); console.log("cxValues",cxValues);
       }
   }

   let cxObj = {...cxScore,cxKeys:cxKeys,cxValues:cxValues};
   setCxScore(cxObj)
}

 const handleKPIChartValues = (values, kpi) =>{  console.log("My KPI handleKPIChartValues",values,kpi); 
    let myChartValueArray, tempScoreVar;
    if(kpi==='cxScoreTrend'){
        tempScoreVar = 'cxscore';
        myChartValueArray = values.map((item)=> item[tempScoreVar]? item[tempScoreVar].toFixed(0): "-");
        console.log("My KPI myChartValueArray--1",kpi," ",myChartValueArray);    
    }
    else{
        tempScoreVar='score';
        myChartValueArray = values.quarterly.map((item)=> item[tempScoreVar]? item[tempScoreVar].toFixed(0): "-");
        console.log("My KPI myChartValueArray--2",kpi," ",myChartValueArray);    
    }
    
    return myChartValueArray;

}
 
const nbas = [
        {
            nba: consts.NEW_IMPROVE_ORDER_VELOCITY,
            primaryRecommendation: primaryRecommendation === consts.NEW_IMPROVE_ORDER_VELOCITY.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.NEW_IMPROVE_ORDER_VELOCITY)
        },
        {
            nba: consts.INCREASE_CREDITLINE,
            primaryRecommendation: primaryRecommendation === consts.INCREASE_CREDITLINE.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.INCREASE_CREDITLINE)
        },
        {
            nba: consts.IMPROVE_INVOICE_AGING,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_INVOICE_AGING.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.IMPROVE_INVOICE_AGING)
        },
        {
            nba: consts.IMPROVE_PRODUCT_AVAILABILITY,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_PRODUCT_AVAILABILITY.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.IMPROVE_PRODUCT_AVAILABILITY)
        },
        {
            nba: consts.IMPROVE_OTIF,
            primaryRecommendation: primaryRecommendation === consts.IMPROVE_OTIF.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.IMPROVE_OTIF)
        },
        {
            nba: consts.REDUCE_RETURN_PERCENTAGE,
            primaryRecommendation: primaryRecommendation === consts.REDUCE_RETURN_PERCENTAGE.toLowerCase() ? true : false,
            isOutlineRequired: utils.getRecommendationFlag(secondaryRecommendations,consts.REDUCE_RETURN_PERCENTAGE)
        }
]
    
return (
        <Spin spinning={loading}>
            <div className={styles.cxContainer}>
                <BreadCrumb
                    list={breadcrumbList}
                    {...props}
                    addToFavorite={addToFavorite}
                    isFavorite={FavoriteId ? true : false} />
                <div className="row no-gutters">
                    <div className={`${subRegionDetails && isattrSectionLoaded? styles.bgColor: styles.nobgColor } ${styles.rightContent} ${"col-sm-12 col-md-12 col-lg-4"}`}>
                        {<Attributes isattrSectionLoaded={isSectionLoaded} code={selectedSubRegion.code} />}
                    </div>
                    <div className={`${styles.leftContent} ${"col-sm-12 col-md-12 col-lg-8"}`}>
                        {
                            subRegionDetails ?
                                <React.Fragment>
                                     <div className={`${styles.layoutBx} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                        <h2 className={styles.cxHeading}>Next Best Actions</h2>
                                        <div className={styles.nbaContainer}>
                                            {
                                                nbas.map((element, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => primaryView(element.nba)}
                                                        className={element.primaryRecommendation ? `${styles.griditem} ${styles.recommended}` :
                                                            element.isOutlineRequired ? `${styles.griditem} ${styles.otherRcmds}` : `${styles.griditem} ${styles.noRcmds} `}
                                                    >{element.nba}</div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className={`${styles.redesignContainer} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                    {   
                                    <div className={`${styles.scoreGridContainer} ${"col-sm-12 col-md-12 col-lg-10"}`}>
                                        <div className={`${styles.scoreGridHeader} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                            <span>CX Score</span>
                                        </div>
                                    
                                        <div className={`${styles.scoreGrid} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                            {<div className={`${styles.cxScoreContainer}`}>
                                                    {cxScore && cxScr && <CXScore cxData={cxScr} cxScore={cxScore} {...props} viewScore={viewScore} />}
                                            </div>}
                                            
                                            <div className={`${styles.kpiContainer}`}>
                                                <div className={`${styles.flexContainer}`}>
                                                {KPI && <KPIScore kpiIndex={3} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                {KPI && <KPIScore kpiIndex={4} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                {KPI && <KPIScore kpiIndex={1} kpi={KPI}   {...props} viewScore={viewScore} />}
                                                </div>
                                                 <div className={`${styles.flexContainer}`}>
                                                 {KPI && <KPIScore kpiIndex={2} kpi={KPI}  {...props} viewScore={viewScore} />}
                                            {KPI && <KPIScore kpiIndex={5} kpi={KPI}    {...props} viewScore={viewScore} />}
                                            {KPI && <KPIScore  kpiIndex={6} kpi={KPI}  {...props} viewScore={viewScore} />}
                                                </div>
                                            </div>
                                          
                                            
                                        </div>
                                    </div>
                                    }
                                    {/*
                                     <div className={`${styles.casContainer}   ${"col-sm-12 col-md-12 col-lg-2"}`}>
                                                    {cas && <CAS  cas={cas} {...props} type={level} viewScore={viewScore} />}
                                     </div>
                                    */}
                                    {
                                        <div className={`${styles.casCustContainer}  ${"col-sm-12 col-md-12 col-lg-2"}`}>
                                            <div className={`${styles.casCustHeader}   ${"col-sm-12 col-md-12 col-lg-12"}`}>CAS</div>
                                                {cas && <CustCAS cas={cas} {...props} viewScore={viewScore} type={level} />}
                                         </div>
                                    }
                                    </div>

                                    {/*<div className={`${styles.scoreGrid} ${"col-sm-12 col-md-12 col-lg-12"}`}>
                                        {cxScore && <CXScore cxScore={cxScore} {...props} viewScore={viewScore} />}
                                        {cas && <CAS cas={cas} {...props} viewScore={viewScore} />}
                                        {cxList && <CXList cxList={cxList} {...props} />}
                                        </div>*/}
                                   
                                   {/* <div className={styles.layoutBx}>
                                        <h2 className={styles.cxHeading}>Journey Map Score</h2>
                                        <div className={styles.underDesign}>Under Design</div>
                                    </div>*/}
                                </React.Fragment> : null
                        }
                    </div>
                   
                </div>
            </div>
        </Spin>
    );
};

export default SubRegion;